module.exports = __webpack_public_path__ + "img/avatar.a33c947d.svg";